// extracted by mini-css-extract-plugin
module.exports = {"main":"Login_main__2OoQD","btnLogin":"Login_btnLogin__3KwrM"};